import { Vec3 } from 'vec3'

interface XRChunkWorld {
  messageQueue: any[]
  isProcessingQueue: boolean
  stopMesherMessagesProcessing: boolean
  processMessageQueue: (source: string) => Promise<void>
  handleMessage: (message: any) => void
  updateCameraSectionPos: () => void
}
interface XRWorldView { updatePosition: (position: Vec3) => Promise<void> }

/** Window RAF pauses in immersive sessions. Service the renderer's public mesher queue on XR RAF. */
export function installXRChunkPump(world: XRChunkWorld, getView: () => XRWorldView | undefined, presenting: () => boolean, now = () => performance.now()) {
  const original = world.processMessageQueue
  world.processMessageQueue = async function (source) {
    if (!presenting()) await original.call(world, source)
  }
  return {
    frame(feet: Vec3) {
      // This public API emits chunkPosUpdate, loads the new spiral and unloads old columns.
      // A clone prevents later server position mutations from changing an in-flight center.
      void getView()?.updatePosition(feet.clone()).catch(error => console.warn('XR chunk center update failed', error))
      world.updateCameraSectionPos()
      if (world.stopMesherMessagesProcessing) return
      const start = now()
      // A previous desktop queue continuation may be parked on window RAF with this flag true.
      // JS callbacks cannot run concurrently; XR owns the queue while presenting.
      world.isProcessingQueue = true
      try {
        let count = 0
        while (world.messageQueue.length && count++ < 64) {
          world.handleMessage(world.messageQueue.shift())
          if (now() - start >= 3) break
        }
      } finally { world.isProcessingQueue = false }
    },
    dispose() { world.processMessageQueue = original },
  }
}
